import { Injectable } from '@angular/core';
import { Capacitor, registerPlugin } from '@capacitor/core';

interface PayrocPlugin {
  startService(): Promise<void>;
  openApp(): Promise<void>;
  returnToPos(): Promise<void>;
}

const PayrocPlugin = registerPlugin<PayrocPlugin>('PayrocPlugin');

@Injectable({
  providedIn: 'root'
})
export class PayrocDeviceService {
  private readonly isNative = Capacitor.isNativePlatform();

  private get plugin(): PayrocPlugin | null {
    if (!Capacitor.isPluginAvailable('PayrocPlugin')) {
      return null;
    }
    return PayrocPlugin;
  }

  /**
   * Step 1: Start Payroc background service (PBCService) on native device.
   * On web or if plugin not present, this is a no-op.
   */
  async startService(): Promise<void> {
    if (!this.isNative || !this.plugin?.startService) {
      // No-op on web or before native plugin is implemented
      return;
    }
    return this.plugin.startService();
  }

  /**
   * Step 3: Switch to Payroc payment UI (MITCActivity).
   */
  async openPayrocApp(): Promise<void> {
    if (!this.isNative || !this.plugin?.openApp) {
      return;
    }
    return this.plugin.openApp();
  }

  /**
   * Step 6: Switch back to our POS/business app.
   */
  async returnToPosApp(): Promise<void> {
    if (!this.isNative || !this.plugin?.returnToPos) {
      return;
    }
    return this.plugin.returnToPos();
  }
}
